import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import {
    delegateeUpdated,
    delegatorUpdated,
    profileUpdated,
    updateDelegateesResponse,
    updateProfileError
} from "./actions";
import {
    DELETE_DELEGATEES,
    GET_DELEGATEE,
    GET_DELEGATOR,
    GET_PROFILE,
    UPDATE_DELEGATEES,
    UPDATE_PROFILE
} from "./actionTypes";
import {createAgent, editAgent, getAgentDetails} from "../../../helpers/agents";
import {createClient, editClient, getClientDetails} from "../../../helpers/clients";
import {createRia, editRia, getRiaDetails} from "../../../helpers/rias";
import {createBd, editBd, getBdDetails} from "../../../helpers/bds";
import {getAgentsAction, getBdsAction, getClientsAction, getRiasAction} from "../../info/actions";
import {deleteDelegatees, getAdminDetails, getDelegatees, getDelegators, updateDelegatees} from "../../../helpers/auth";

function* getProfileSaga({payload: {history}}) {
    try {
        const user = JSON.parse(localStorage.getItem("authUser"));
        if (!user) {
            return;
        }
        if (user.group === "admin") {
            const profile = yield call(getAdminDetails);
            yield put(profileUpdated(profile));
        }
        if (user.group === "bd") {
            const profile = yield call(getBdDetails, {id: user.id});
            yield put(profileUpdated(profile));
        }
        if (user.group === "ria") {
            const profile = yield call(getRiaDetails, {id: user.id});
            yield put(profileUpdated(profile));
        }
        if (user.group === "agent") {
            const profile = yield call(getAgentDetails, {id: user.id});
            yield put(profileUpdated(profile));
        }
        if (user.group === "client") {
            const clientType = user.id.startsWith("IC") ? "individual" : "corporate";
            const profile = yield call(getClientDetails, {clientType, id: user.id.substring(2)});
            yield put(profileUpdated(profile));
        }
    } catch (error) {
        if (error.status === 401) {
            localStorage.removeItem("authUser");
            history.push("/login");
        }
        console.error(error);
    }
}

function* updateProfileSaga({payload: {id, data, history}}) {
    try {
        const user = JSON.parse(localStorage.getItem("authUser"));
        if (user.group === "bd") {
            let profile;
            if (id) {
                profile = yield call(editBd, id, data);
            } else {
                profile = yield call(createBd, data);
            }
            const newProfile = yield call(getBdDetails, profile);
            yield put(getBdsAction());
            yield put(profileUpdated(newProfile));
        }
        if (user.group === "ria") {
            let profile;
            if (id) {
                profile = yield call(editRia, id, data);
            } else {
                profile = yield call(createRia, data);
            }
            const newProfile = yield call(getRiaDetails, profile);
            yield put(getRiasAction());
            yield put(profileUpdated(newProfile));
        }
        if (user.group === "agent") {
            let profile;
            if (id) {
                profile = yield call(editAgent, id, data);
            } else {
                profile = yield call(createAgent, data);
            }
            const newProfile = yield call(getAgentDetails, profile);
            yield put(getAgentsAction());
            yield put(profileUpdated(newProfile));
        }
        if (user.group === "client") {
            let profile;
            if (id) {
                profile = yield call(editClient, id, data);
            } else {
                profile = yield call(createClient, data);
            }
            const newProfile = yield call(getClientDetails, profile);
            yield put(getClientsAction());
            yield put(profileUpdated(newProfile));
        }
    } catch (error) {
        if (error.status === 401) {
            localStorage.removeItem("authUser");
            history.push("/login");
        }
        console.error(error);
        yield put(updateProfileError(error));
    }
}

function* getDelegatorSage(){
    const delegators = yield call(getDelegators);
    if(delegators){
        yield put(delegatorUpdated(delegators));
    }
}

function* getDelegateeSage(){
    const delegatees = yield call(getDelegatees);
    if(delegatees){
        yield put(delegateeUpdated(delegatees));
    }
}

function* updateDelegateeSage({payload: {delegatees, history}}){
    try{
        const res= yield call(updateDelegatees, {delegatees});
        const newDelegatees = yield call(getDelegatees);
        yield put(delegateeUpdated(newDelegatees));
        yield put(updateDelegateesResponse({success: true, data: res.data}));
    } catch (error) {
        if (error.status === 401) {
            localStorage.removeItem("authUser");
            history.push("/login");
        }
        console.error(error);
        yield put(updateDelegateesResponse({success: false, error: error}));
    }
}

function* deleteDelegateesSage({payload: {ids, history}}) {
    try {
        yield call(deleteDelegatees, {ids});
        const newDelegatees = yield call(getDelegatees);
        yield put(delegateeUpdated(newDelegatees));
    } catch (error) {
        if (error.status === 401) {
            localStorage.removeItem("authUser");
            history.push("/login");
        }
        console.error(error);
        yield put(updateDelegateesResponse({success: false, error: error}));
    }
}

export function* watchGetProfileSaga() {
    yield takeEvery(GET_PROFILE, getProfileSaga);
}

export function* watchUpdateProfileSaga() {
    yield takeEvery(UPDATE_PROFILE, updateProfileSaga);
}

export function* watchGetDelegatorSaga() {
    yield takeEvery(GET_DELEGATOR, getDelegatorSage);
}

export function* watchGetDelegateeSaga() {
    yield takeEvery(GET_DELEGATEE, getDelegateeSage);
}

export function* watchUpdateDelegateeSaga() {
    yield takeEvery(UPDATE_DELEGATEES, updateDelegateeSage);
}

export function* watchDeleteDeleagteesSaga() {
    yield takeEvery(DELETE_DELEGATEES, deleteDelegateesSage);
}

function* userSaga() {
    yield all([
        fork(watchGetProfileSaga),
        fork(watchUpdateProfileSaga),
        fork(watchGetDelegatorSaga),
        fork(watchGetDelegateeSaga),
        fork(watchUpdateDelegateeSaga),
        fork(watchDeleteDeleagteesSaga)
    ]);
}

export default userSaga;
